export default "__VITE_ASSET__D6R5WPVf__"